import {
    get, post
} from '@/utils/request'

const SERVICE_URL = '/project-service/v1'

/** 技术包通知管理 */
export function fetchTechList(params) { 
    return post(SERVICE_URL + '/tech/list', params)
}

// /** 技术包通知（弹窗） */
// export function fetchTechList2(params) {
//     return post(SERVICE_URL + '/tech/list2', params)
// }
export function deleteTech(params) {
    console.log(params)
    return post(SERVICE_URL + '/tech/deleteBatch', params)
}
export function createTechNoti(params) {
    return post(SERVICE_URL + '/tech/add', params)
}

export function getTechNotiById(params, pathParam) {
    return get(SERVICE_URL + '/tech/getById', params, pathParam)
}

export function editTechNoti(params) {
    return post(SERVICE_URL + '/tech/edit', params)
}

export function statusList(params) {
    return post(SERVICE_URL + '/tech/statusList', params)
}
export function statusExport(params) {
    return post(SERVICE_URL + '/tech/statusExport', params)
}

export function getTechnicalByTechCode(params, pathParam) {
    return get(SERVICE_URL + '/tech/getByTechCode', params, pathParam)
}

/** 零件管理 */
export function getPartList(params) {
    return post(SERVICE_URL + '/part/list', params)
}

export function getPartById(params, pathParam) {
    return get(SERVICE_URL + '/part/getById', params, pathParam)
}

export function editPart(params) {
    return post(SERVICE_URL + '/part/edit', params)
}

export function createPart(params) {
    return post(SERVICE_URL + '/part/add', params)
}

export function createPartList(params) {
    return post(SERVICE_URL + '/part/addList', params)
}

export function deletePart(params) {
    console.log(params)
    return post(SERVICE_URL + '/part/deleteBatch', params)
}



// 任务列表零件
export function getTaskApparmentList(params) {
    return post(SERVICE_URL + '/part/listTaskPart', params)
}

export function getTaskPartIdsByTaskId(params, pathParam) {
    return get(SERVICE_URL + '/part/getTaskPartIdsByTaskId', params, pathParam)
}

export function deleteTaskApparmentByIds(params) {
    return post(SERVICE_URL + '/part/removeTaskPartByIds', params)
}

export function updateTaskApparmentByIds(params) {
    return post(SERVICE_URL + '/part/updateTaskPartByIds', params)
}

/** 供应商管理 */
export function getSupplierList(params) {
    return post(SERVICE_URL + '/supplier/list', params)
}

export function deleteSupplier(params) {
    console.log(params)
    return post(SERVICE_URL + '/supplier/deleteBatch', params)
}

export function getSupplierById(params, pathParam) {
    return get(SERVICE_URL + '/supplier/getById', params, pathParam)
}

export function createSupplier(params) {
    return post(SERVICE_URL + '/supplier/add', params)
}

export function editSupplier(params) {
    return post(SERVICE_URL + '/supplier/edit', params)
}

export function getTechSupplierList(params) {
    return post(SERVICE_URL + '/supplier/getRecomendedSupplierByTechnicalCode', params)
}

/** 招标管理 */
export function getBiddingList(params) {
    return post(SERVICE_URL + '/bidding/list', params)
}

export function deleteBidding(params) {
    console.log(params)
    return post(SERVICE_URL + '/bidding/deleteBatch', params)
}

export function getBiddingById(params, pathParam) {
    return get(SERVICE_URL + '/bidding/getById', params, pathParam)
}

export function createBidding(params) {
    return post(SERVICE_URL + '/bidding/add', params)
}

export function createBiddings(params) {
    return post(SERVICE_URL + '/bidding/adds', params)
}

export function editBidding(params) {
    return post(SERVICE_URL + '/bidding/edit', params)
}

/** 招标模板管理 */
export function getBiddingTemplateList(params) {
    return post(SERVICE_URL + '/biddingTemplate/list', params)
}

// export function deleteBidding(params) {
//     console.log(params)
//     return post(SERVICE_URL + '/bidding/deleteBatch', params)
// }

// export function getBiddingById(params, pathParam) {
//     return get(SERVICE_URL + '/bidding/getById', params, pathParam)
// }

// export function createBidding(params) {
//     return post(SERVICE_URL + '/bidding/add', params)
// }

// export function editBidding(params) {
//     return post(SERVICE_URL + '/bidding/edit', params)
// }

export function importFile(params) {
    return importData(SERVICE_URL + '/part/import', params)
}

/** 审批历史管理 */
export function getApprovalList(params) {
    return post(SERVICE_URL + '/technicalApproval/list', params)
}